import React, { useEffect } from 'react';
import HeaderTwo from '../../components/HeaderTwo';
import { Styles } from './styles/welcome.js';


const Welcome = (props) => {
    // console.log("History", props)
    // useEffect(() => {
    //     document.body.scrollTop = 0;
    //     document.documentElement.scrollTop = 0;
    //     window.fbq('track', 'CompleteRegistration');
    // })
    // console.log(window);
    return (
        <div>
            <HeaderTwo />
            <Styles>
                <div className="container CongratulationComponent">
                    <div className="row">
                        <div className="col-md-12">
                            <iframe width="100%" height="440px" src="https://www.youtube.com/embed/ShXPzizvASA?autoplay=1" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

                        </div>
                    </div>
                </div>
                <hr className="hrCustom" />
                <div className="container CongratulationComponent">
                    <div className="row Section7">
                        <div className="col-md-6 backImage">
                        </div>
                        <div className="col-md-6">

                            <div className="p-5 mt-5">
                                <ul className="imageList">
                                    <li> <h3 className="">WE ARE NOW GOING TO SET UP YOUR LEARNING JOURNEY</h3></li>
                                    <br />
                                    <li> <h3 className="">IT WILL BE ACTIVE IN 48 HOURS</h3></li>
                                    <br />
                                    <li> <h3 className="">OUR TEAM WILL CALL YOU AS SOON AS YOUR ACCOUNT IS SET UP</h3></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="hrCustom" />

                <div className="container CongratulationComponent">
                    <div className="row Section2">
                        <div className="col-md-6">
                            <img src={"/assets/images/LM/Picture3.jpg"} class="img-fluid imageSection2" alt="Responsive image" />
                        </div>
                        <div className="col-md-6 mt-5">
                            <h3 className="ReadyHeading">ARE YOU READY TO</h3>
                            <div className="YellowBox">
                                <h3>LEARN ONLINE</h3>
                            </div>
                            <br />
                            <div className="paragraphText">
                                <p>We are so excited that you have choosen us for your learning needs. </p>
                                <p>We work with professional teachers who are familiar with how to manage kids’ learning needs through online learning sessions</p>
                                <p>We will provide all the material, so you do not need to purchase anything. Just ensure that you have a stable internet connection.</p>
                                <p>Let’s start!</p>
                            </div>
                        </div>
                    </div>
                </div>

                <hr className="hrCustom" />

                <div className="container CongratulationComponent">

                    <div className="row Section3">
                        <div className="col-md-12">
                            <img src={"/assets/images/LM/Picture4.jpg"} class="img-fluid imageSection3Cover" alt="Responsive image" />
                            <img src={"/assets/images/LM/Picture5.png"} class="img-fluid imageSection3Zoom" alt="Responsive image" />
                        </div>
                        <div className="col-md-6 marginForMobile">
                            <h3 className="ReadyHeading">CONNECT WITH US</h3>
                            <div>
                                <h3 className="YellowBox">LEARN ONLINE</h3>
                            </div>
                            <h3 className="ReadyHeading">IT’S REALLY EASY</h3>
                        </div>
                        <div className="col-md-6 paragraphText marginForMobile">
                            <p>We teach all our online classes using a video conferencing software developed by ZOOM.</p>
                            <p>Its really easy to use, and kids love it.</p>
                            <p>We will be sending you a step by step guide on how to install and operate ZOOM. It’s really easy!</p>
                        </div>
                    </div>

                </div>
                <hr className="hrCustom" />

                <div className="container CongratulationComponent">

                    <div className="row Section4">
                        <div className="col-md-6 mt-5">
                            <h3 className="ReadyHeading">YOU WILL GET </h3>
                            <h3 className="ReadyHeading">YOUR OWN ONLINE</h3>
                            <h3 className="ReadyHeading">LEARNING JOURNEY</h3>
                            <br />
                            <div className="paragraphText">
                                <p>Your teacher will go over the course chapter by chapter.</p>
                                <p>You will have your own online dashboard through which you can complete all your work.</p>
                                <p>All students will be taking quizzes and quick tests so that the teacher can constantly see the improvements that are being made.</p>
                            </div>
                        </div>
                        <div className="col-md-6 backImage">

                            {/* <img src={Picture6} class="img-fluid backImage" alt="Responsive image" /> */}
                        </div>
                    </div>
                </div>
                <hr className="hrCustom" />
                <div className="container CongratulationComponent">

                    <div className="row Section5">
                        <div className="col-md-6 mt-5">
                            <h3 className="ReadyHeading">YOU WILL GET </h3>
                            <h3 className="ReadyHeading">YOUR OWN ONLINE</h3>
                            <h3 className="ReadyHeading">LEARNING JOURNEY</h3>
                            <br />
                            <div className="paragraphText">
                                <p>Your teacher will go over the course chapter by chapter.</p>
                                <p>You will have your own online dashboard through which you can complete all your work.</p>
                                <p>All students will be taking quizzes and quick tests so that the teacher can constantly see the improvements that are being made.</p>
                            </div>
                        </div>
                        <div className="col-md-6 backImage">

                            {/* <img src={Picture6} class="img-fluid backImage" alt="Responsive image" /> */}
                        </div>
                    </div>
                </div>
                <hr className="hrCustom" />
                <div className="container CongratulationComponent">
                    <div className="row Section6">
                        <div className="col-md-7">
                        </div>
                        <div className="col-md-5 blackBackgroundDesign">
                            <div className="p-5 mt-5">
                                <h3 className="">PRACTICE </h3>
                                <h3 className="">MAKES</h3>
                                <h3 className="ReadyHeading">PERFECT</h3>
                                <br />
                                <div className="paragraphText">
                                    <p>If you are weak in a topic, you will be able to do practice problems after the class.</p>
                                    <p>Our technology will help you learn throughout the course</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <hr className="hrCustom" />
                <div className="container CongratulationComponent">

                    <div className="row Section8">
                        <div className="col-md-6">
                            <div className="">
                                <img src={"/assets/images/LM/logo.png"} class="logoSize" alt="Responsive image" />
                            </div>
                        </div>
                        <div className="col-md-12 mt-4">
                            <h4>TERMS OF SERVICE</h4>
                            <h5>Parents’ involvement in class matters</h5>
                            <p>We encourage parents to help their child excel, and participate with the child after the class has been completed. However, we discourage parents’ interference in how the teacher is running the class. We discourage the interference because the parent would unknowingly, and unintentionally be bringing in a biased point of view, which might not be a part of the learning journey that has been planned for the class.</p>
                            <br />
                            <h5>Our teachers cover all chapter in the curriculum in a particular sequence</h5>
                            <p>Since we are catering a collective group of students, the teachers will follow a set learning journey of the Chapters within the curriculum. This is to ensure that all the aspects of each topic are covered. If your child already knows the work, he is encouraged to take the test for that topic and move on to the next topic.
</p>
                            <br />
                            <h5>Teachers use the mute option </h5>
                            <p>Our teachers are encouraged to use the mute option when teaching a class. This helps control the ambient noise coming from the other student, and maintains a particular decorum of the class. This strategy also avoids any embarrassing situation for a student if their mic picks up comment or a noise from the ecosystem. Students are encouraged to use the "raise hand" option is they do not understand something, or if they have a question or comment and would like to contribute.
</p>
                            <br />
                            <h5>Teachers may spot check of homework</h5>
                            <p>Since our technology uses autocorrect for its tests (which are a part of the homework), the teacher may decide to conduct regular spot checks to see how the students are progressing.
</p>
                            <p>Students are expected to do the assigned homework. The majority of the homework and corresponding videos that explain the concepts. The teacher reserves the right to conduct unannounced spot check to see if the child has completed their homework.
</p>
                            <br />
                            <h5>We discourage late arrivals</h5>
                            <p>We discourage students coming late to class for several reasons, which include the possibility that a student might miss a key point discussed by the teacher; it would be unfair to other students if the late arrival is catered to during class.
</p>
                            <p>In case a student arrives late to class, we have several learning resources in the form of curated videos that are available at our system to cover up anything the student might have missed.
</p>
                            <br />
                            <h5>Additional time to facilitate the student requires special permission from the Administration team</h5>
                            <p> In very rare cases, the teacher may agree to give additional personal time to facilitate a student who is falling behind and needs extra attention. However, in such rare cases, Lincoln Method’s Administration needs to approve special permission for added time given by the teacher. Please note that there might be an additional cost (depending upon the nature of the request).</p>

                            <br />
                            <h5>How absentees can catch up on missed work</h5>
                            <p>It is understandable that on a certain day, a student will be absent. Parents will be notified of what work is missed. It is the students’ responsibility to review the work and watch any supporting videos, and complete any work that was assigned for that day.
</p>
                            <p>If the student is falling behind and wants an additional one-on-one session with the teacher, then the school's administration needs to be contacted, so that the teacher's schedule can be managed and an additional class can be put together for the student.

</p>
                            <p>We discourage the practice of a special one-on-one class with the teacher because it is difficult to schedule a time with the teacher since they have classes continuously throughout the day. To discourage any requests for one-on-one classes, we will be charging an additional fee for that extra class.
</p>
                            <br />
                            <h5>Bullying is not appreciated</h5>
                            <p>Since the younger generation has a tendency to have elevated levels of excitement, there can be cases when a student says something to another student during the Zoom session, which could come across as being hurtful. In such cases, our Administration will try to bring both students and their parents together and let them sort it out.
</p>
                            <p>We would like to highlight that we consider all students who come to our school are from respectable families and would be able to follow a proper code of conduct.
</p>

                            <br />
                            <h5>Teachers will be able to provide a limited role as tech support during a class</h5>
                            <p>It is understandable that students who are new to Zoom are not aware of the feature and functionality of Zoom. It will be unfair to other students is teachers to help a new student get their bearings on how to use Zoom during a live class session.
</p>
                            <p>This is why we highly recommend that students practice how to login into their account before their first class.
</p>
                            <br />
                            <h5>How will public holidays be counted in the billing cycle</h5>
                            <p>Our billing cycle operates just like any other school that charges it's fees on monthly basis. Parents will receive their fee bill at the beginning of their monthly billing cycle. As a sign of respect the all stakeholders, our Online School will not offer classes on public holidays. Our teachers will continue the learning journey with the students after they return from the public holiday(s). Students will have access to our entire online system at all times, and they are welcome to carry out their learning journey independently if the choose to do so </p>
                            <br />
                            <h5>No refunds</h5>
                            <p>Since the school is run as a community project (as is reflected by the lowered fees that we charge), it is not feasible for us to issue any refunds or replacement classes.
</p>
                        </div>
                    </div>
                    <br />
                </div>
            </Styles>
        </div>);
}

export default Welcome;